import Flickity from "flickity";
import { isOver } from "../../js/lib/util";

import "../image/image.vue.ts";
import { createApp, defineComponent } from "vue";

const breakpoint = 767;
const third = 100 / 3;

export default (el: HTMLElement) => {
  const componentDefinition = defineComponent({
    data: function () {
      return {
        scrollPercent: 0,
        isMounted: false,
        flickity: null as Flickity | null,
      };
    },
    methods: {
      init() {
        this.$nextTick(() => {
          this.flickity = new Flickity(this.$refs["carousel"] as HTMLElement, {
            cellAlign: "left",
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: true,
            freeScroll: false,
            wrapAround: true,
          });
        });
      },
      destroy() {
        this.flickity?.destroy();
        this.flickity = null;
      },
      onResize() {
        if (!this.$flickity) {
          if (!isOver(breakpoint)) this.init();
        } else {
          if (isOver(breakpoint)) this.destroy();
        }
      },
      onScroll() {
        const bgTop = this.$refs["footer-bg"].getBoundingClientRect().top;
        const docHeight = document.documentElement.clientHeight;

        const scrollPercent = 100 - (bgTop / docHeight) * 100;

        if (scrollPercent < 0) {
          this.scrollPercent = 0;
        } else if (scrollPercent > 100) {
          this.scrollPercent = 100;
        } else {
          this.scrollPercent = scrollPercent;
        }
      },
    },
    mounted() {
      this.isMounted = true;

      if (!isOver(breakpoint)) this.init();

      window.addEventListener("resize", () => {
        this.onResize();
      });

      if (this.$refs["footer-bg"]) {
        window.addEventListener("scroll", () => {
          this.onScroll();
        });
      }
    },
    computed: {
      bgClipPath() {
        let left = null;
        let right = null;
        let top = null;
        let bottom = null;

        // Offset the scroll by 20% to make animation start and finish earlier
        const offsetScrollPercent =
          window.innerHeight + window.scrollY >= document.body.offsetHeight
            ? this.scrollPercent + 45
            : this.scrollPercent + 20;

        if (offsetScrollPercent < third) {
          left = 50 - ((offsetScrollPercent / third) * 100) / 2;
          right = 50 + ((offsetScrollPercent / third) * 100) / 2;
          top = 0;
          bottom = 2;

          return `clip-path: polygon(${left}% ${top}%, ${right}% ${top}%, ${right}% ${bottom}%, ${left}% ${bottom}%)`;
        } else if (
          offsetScrollPercent >= third &&
          offsetScrollPercent <= 2 * third
        ) {
          left = 0;
          right = 100;
          top = 0;
          bottom = (offsetScrollPercent / third) * 100 - 100;

          return `clip-path: polygon(${left}% ${top}%, ${right}% ${top}%, ${right}% ${bottom}%, ${left}% ${bottom}%)`;
        } else {
          left = ((offsetScrollPercent - 2 * third) * 3) / 2;
          right = 100 - ((offsetScrollPercent - 2 * third) * 3) / 2;
          top = 98;
          bottom = 100;

          return `clip-path: polygon(0 0, 0 ${bottom}%, ${left}% ${bottom}%, ${left}% ${top}%, ${right}% ${top}%, ${right}% 100%, ${right}% ${bottom}%, ${right}% ${bottom}%, 100% ${bottom}%, 100% 0)`;
        }
      },
    },
  });

  const instanceApp = createApp(componentDefinition as any);
  return instanceApp.mount(el);
};
